import React from "react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@/Components/ui";
import { TableOrderPayment } from "@/api/services/pos.service";
import { TableOrder } from "@/api/services/table-order.service";

const formatDateTime = (value: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

type PostCancelDecisionModalProps = {
  isOpen: boolean;
  order: TableOrder | null;
  latestCancelPayment: TableOrderPayment | null;
  canCancelOrder: boolean;
  isSubmitting: boolean;
  onReopenPayment: () => Promise<void>;
  onCancelOrder: () => Promise<void>;
};

const PostCancelDecisionModal = ({
  isOpen,
  order,
  latestCancelPayment,
  canCancelOrder,
  isSubmitting,
  onReopenPayment,
  onCancelOrder,
}: PostCancelDecisionModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} size="lg" variant="dialog" centered>
      <ModalHeader>결제 취소 후 처리 선택</ModalHeader>
      <ModalBody className="space-y-4">
        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
          결제 취소가 완료되었습니다. 같은 주문으로 재결제를 이어갈지, 주문 내역까지 취소할지 선택해주세요.
        </div>

        <div className="rounded-3xl border border-slate-200 p-4 text-sm text-slate-700">
          <div className="mb-2 flex items-center justify-between gap-2">
            <strong className="text-slate-800">주문 #{order?.id || "-"}</strong>
            <span className="text-slate-500">취소 완료: {formatDateTime(order?.canceled_payment_at || latestCancelPayment?.completed_at || null)}</span>
          </div>
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
            <div>테이블: {order?.table_name || (order?.order_type === "pickup" ? "픽업" : "테이블 미지정")}</div>
            <div>총 금액: {order ? `${order.total_amount.toLocaleString()}원` : "-"}</div>
            <div>주문 상태: {order?.status || "-"}</div>
            <div>승인번호: {latestCancelPayment?.approval_number || "-"}</div>
          </div>
        </div>

        {!canCancelOrder ? (
          <div className="rounded-3xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-700">
            현재 주문 상태에서는 주문 내역까지 취소할 수 없습니다. 같은 주문으로 재결제만 이어갈 수 있습니다.
          </div>
        ) : null}
      </ModalBody>
      <ModalFooter>
        {canCancelOrder ? (
          <Button color="soft-danger" onClick={() => void onCancelOrder()} disabled={isSubmitting}>
            {isSubmitting ? "처리 중..." : "주문도 취소"}
          </Button>
        ) : null}
        <Button color="primary" onClick={() => void onReopenPayment()} disabled={isSubmitting}>
          {isSubmitting ? "처리 중..." : "같은 주문으로 재결제"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PostCancelDecisionModal;